import { SubPageLayout } from "@/components/SubPageLayout";

export default function DekoracioEltavolitas() {
  return (
    <SubPageLayout
      eyebrow="Dekorációeltávolítás"
      title="Régi grafika eltávolítása."
      intro="Megváltozott céges arculat? Új járműpark? Régi reklámdekorációkat, grafikákat és matricákat profin eltávolítunk – akár új grafika kerül a helyére, akár csak letakarítjuk."
      heroImage="/assets/gallery/dekoracio-eltavolitas.webp"
      bullets={[
        { title: "Profi eltávolítás", text: "Megfelelő technikával a lehető legkíméletesebben." },
        { title: "Felület-előkészítés", text: "Ragasztómaradvány, festék, koszolódás teljes letakarítása." },
        { title: "Új arculat", text: "Ha újjá nem is varázsoljuk autóját, a régi dekoráció lecserélésével teljesen új életre keltjük." },
      ]}
    />
  );
}
